module.exports = __webpack_public_path__ + "static/kdb-banner-3@2x-d009e8d135ff576af8995acdbd749473.webp";